<template>
    <Dropdown
        placement="bottom-end"
        transfer
        trigger="custom"
        :visible="modelValue"
        @onClickoutside="$emit('update:model-value', false)"
    >
        <SquareButton :class="$style.button" :is-active="modelValue" @click="$emit('update:model-value', !modelValue)">
            <Icon size="22" type="ios-more" data-testid="banner-footer__options-button" />
        </SquareButton>

        <template #list>
            <DropdownItem
                v-for="option in options"
                :key="option.label"
                :divided="option.divided"
                @click="onOptionClick(option)"
            >
                <div :class="$style.label" :data-testid="`banner-footer__options-${option.id}`">
                    <Icon v-if="option.icon" :type="option.icon" />
                    <span>{{ option.label }}</span>
                </div>
            </DropdownItem>
        </template>
    </Dropdown>
</template>

<script lang="ts" setup>
import SquareButton from "@/components/common/SquareButton.vue";
import { useGA4Tracking } from "@/composables/useGA4Tracking";
import GA4 from "@/enums/ga4Events";

const { options } = defineProps<{
    modelValue: boolean;
    options: { id: string; label: string; icon?: string; divided?: boolean; onClick: () => void }[];
}>();

const $emit = defineEmits<{
    (e: "update"): void;
    (e: "update:model-value", show: boolean): void;
}>();

const ga4 = useGA4Tracking();

function onOptionClick(option: { id: string; label: string; onClick: () => void }) {
    ga4.trackClickEvent({
        interactionObject: GA4.CLICK_INTERACTION_OBJECTS.BUTTON,
        interactionText: `${GA4.CLICK_INTERACTION_TEXTS.TEMPLATE_OPTIONS} - ${option.label}`
    });
    option.onClick();
}
</script>

<style lang="css" module>
.button {
    flex-basis: 40px;
}

.label {
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
